import React from "react";
import { Navigate } from "react-router-dom";

export default function PublicOnlyRoute({ children }) {
  const isAuthed = !!localStorage.getItem("authToken");
  const backendDown = sessionStorage.getItem("backendDown") === "1";

  if (isAuthed && !backendDown) {
    return <Navigate to="/" replace />;
  }

  return children;
}
